import { WHITE } from '../primitives/color.js'
import { squareName, type Square } from '../primitives/square.js'
import { boardToFen } from './fen.js'
import type { Position } from './position.js'

/**
 * A comparison key for repetition detection.
 *
 * Deliberately *not* the full FEN: the halfmove and fullmove counters differ
 * between repetitions of the same position, and the en passant square must only
 * count when a capture is actually available — otherwise a pawn double-push
 * that nobody can answer would make two identical positions compare unequal.
 * Deciding that requires move generation, so the caller passes in the narrowed
 * value; see `game/repetition.ts`.
 */
export const positionKey = (pos: Position, capturableEpSquare: Square | null): string =>
  `${boardToFen(pos)} ${pos.turn === WHITE ? 'w' : 'b'} ${pos.castling} ${
    capturableEpSquare === null ? '-' : squareName(capturableEpSquare)
  }`
